import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./../styles";
import { PDFTableColumn } from "ui/components/PDF/Table";

export interface PDFTableRowProps<T> {
  item: T;
  columns: PDFTableColumn<T>[];
  backgroundColor?: string;
}

function PDFTableRow<T>({
  item,
  columns,
  backgroundColor,
}: PDFTableRowProps<T>) {
  const styles = makePdfStyleSheet({
    tableRow: {
      backgroundColor,
    },
  });

  const getCellStyle = (column: {
    width?: number | string;
    flex?: number;
    fontSize?: number;
    paddingHoizontal?: number;
  }) =>
    makePdfStyleSheet({
      tableRowCell: column,
    }).tableRowCell;

  return (
    <View style={[styles.flexRow, styles.tableRow]}>
      {columns.map((column, index) =>
        !column.shouldHide ? (
          <View style={getCellStyle(column)} key={index}>
            {column.render ? (
              column.render(item, index)
            ) : column.accessor ? (
              <Text>{item[column.accessor]}</Text>
            ) : (
              <></>
            )}
          </View>
        ) : null
      )}
    </View>
  );
}

export default PDFTableRow;
